<template>
  <div id="container" class="container">
    <main class="p-login">
      <div class="p-login__inner">
        <div class="p-login-body">
          <div class="p-login-body__inner">
            <div class="logo">
              <img src="@/styles/img/login/img_logo.svg" alt="MANAVIRIA">
            </div>
            <form class="p-login-form" @submit.prevent="login">
              <dl class="p-login-form__row">
                <dt class="p-login-form__row__title">ユーザーID</dt>
                <dd class="p-login-form__row__detail">
                  <div class="formUitextbox formUitextbox--user">
                    <input type="text" class="formUiTextfield" placeholder="ユーザーID" v-model="username" name="username" autocomplete="on">
                  </div>
                </dd>
              </dl>
              <dl class="p-login-form__row">
                <dt class="p-login-form__row__title">パスワード</dt>
                <dd class="p-login-form__row__detail">
                  <div class="formUitextbox formUitextbox--password">
                    <input :type="isPassword?'text':'password'" class="formUiTextfield" placeholder="パスワード" v-model="password" name="password" autocomplete="on">
                  </div>
                  <label><input type="checkbox" v-model="isPassword" name="showPassword">パスワードを表示する</label>
                </dd>
              </dl>
              <div class="p-login-form__attention">
                <div ref="refAuthErrorMessage">
                  <p v-for="(message, index) in errorMessages" :key="index">{{message}}</p>
                </div>
              </div>
              <div class="p-login-form__footer">
                <button-login :enabled="isEnabled && isProcessing" name="S1-1-login-btn">ログイン</button-login>
                <p class="attentionText">IDやパスワードを忘れた場合は、先生へお問い合わせください。</p>
                <ul class="c-link -login">
                  <li class="c-link__item">
                    <a href="https://www.meijitosho.co.jp/gakusan/manaviria/help/student/" target="_blank">使い方についてはこちら</a>
                  </li>
                  <li class="c-link__item">
                    <a href="https://www.meijitosho.co.jp/gakusan/manaviria/help/student/faq/" target="_blank">よくある質問</a>
                  </li>
                  <li class="c-link__item">
                    <a href="https://manavi.wikipy.jp/student/p432" target="_blank">お問い合わせ</a>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
        <div class="p-login-tutorial" v-if="getHelp.length">
          <a href="javascript:void(0)" class="btn" @click="showHelp"><span class="label">？</span></a>
        </div>
      </div>
    </main>
    <popup-modal v-model="helpModal" @close="helpModal=false" @close-layer="helpModal=false" :is-help-modal="true">
      <template #main v-if="getHelp.length">
        <div class="topUseBlock">
          <div class="title">{{getHelp[0].screen_name}}</div>
          <markdown-view :rawText="getHelp[0].body" :souruby="true"></markdown-view>
        </div>
      </template>
      <template #footer>
        <a class="c-button-white -close" @click="helpModal=false">
          <span class="label">
            閉じる
          </span>
        </a>
      </template>
    </popup-modal>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted} from 'vue';
  import { useRouter, useRoute } from 'vue-router'
  import { event } from 'vue-gtag'
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useAuthStore } from '@/store/student/auth_store';

  const router = useRouter()
  const route = useRoute()

  const username = ref('');
  const password = ref('');
  const isPassword = ref(false);
  const helpModal = ref(false);
  const errorMessages = ref<string[]>([]);;
  const isProcessing = ref(true);

  const refAuthErrorMessage = ref<HTMLInputElement | null>(null)

  const isEnabled = computed(() => {
    if(username.value && password.value) {
      return true;
    }
    return false
  })
  const getHelp = computed(() => {
    return useGlobalNavigationStore().helpList.filter((item) => item.screen_code === route.meta.screenCode)
  })

  function showHelp(): void {
    helpModal.value = true
    if(isEnvCaptureGoogleAnalyticsEvents()){
      event('show_help', {
          'screen_code': route.meta.screenCode
      })
    }
  }
  function login (): void {
    refAuthErrorMessage.value.classList.remove("bounce")
    if(!isEnabled.value){
      return
    }
    isProcessing.value = false
    useAuthStore().authLogin(username.value, password.value)
    .then(async (instance)=>{
      // for successfully login
      if(instance.data.result === "ok") {
        const query:any = route.query
        if(query.next){
          if(query.next.startsWith("/student/")){
            router.push({path: query.next})
          }else{
            router.push({name: "top"})
          }
        }else{
          router.push({name: "top"})
        }
      }
      // login not success
      else {
        errorMessages.value = instance.data.messages
        refAuthErrorMessage.value.classList.add("bounce")
        isProcessing.value = true
      }
    })
    .catch(() => {
      isProcessing.value = true
    })
  }
  onMounted(async() => {
    document.title = "生徒ログイン画面 - MANAVIRIA"
    const authStore = useAuthStore()
    if(authStore.prUsername && authStore.prPassword){
      username.value = authStore.prUsername
      password.value = authStore.prPassword
    }
    if(route.query.pr_username && route.query.pr_password){
      // prログインの場合はid,pwをstoreに保存する
      authStore.prLogin(String(route.query.pr_username), String(route.query.pr_password))
      router.replace({'query': null})
    }
    await useGlobalNavigationStore().fetchHelp()
  })
</script>
